// © Microsoft Corporation. All rights reserved.

import {
    environment,
    initializeMessageHandler,
    loadConfigTree,
    perfMarker,
    registerConfigResolverTasks,
    registerContentPreviewTasks,
    registerFeedDisplaySettingListener,
    registerFetchAppAnonCookie,
    registerFetchIndustryNewsArticles,
    registerLocalNewsTasks,
    registerMyBriefingTasksForEdgeChromium,
    registerOneServiceFeedTasksForEdgeChromium,
    registerOneServiceTokenListener,
    registerPdpTasks,
    registerWpoFeedTasksForEdgeChromium
} from "@msnews/web-worker";

import { AudienceModeType } from "@msnews/config-data-types";

(() => {
    // since we can't use perfMarker until after environment is initialized,
    // capture the raw time offset at start now, so we can use it after init.
    const startTime = performance.now();

    // Initialize environment variables
    environment.init();

    // record with the custom time we saved earlier once environment has been fully initialized.
    perfMarker("Start", startTime);

    // Add message listener first to avoid missing messages from main thread
    initializeMessageHandler();

    // Add listener for feed display setting. This is Anaheim specific
    registerFeedDisplaySettingListener();

    // Add listener for Edge Chromium AadToken
    registerOneServiceTokenListener();

    // Register tasks dependent on/should wait for other tasks here
    registerConfigResolverTasks();

    // These markets are running on pure React by default still
    const pureReactMarkets = new Set<string>(["ko-kr", "ja-jp", "ru-ru"]);
    if (environment.currentFlights && (environment.currentFlights.includes("prg-webcomp")
        || environment.currentFlights.includes("prg-wpo-singcol2")
        || environment.currentFlights.includes("prg-northstar")
        || (!pureReactMarkets.has(environment.locale) && environment.audienceMode !== AudienceModeType.Enterprise))) {
        registerWpoFeedTasksForEdgeChromium();
    } else {
        registerOneServiceFeedTasksForEdgeChromium();
    }

    registerMyBriefingTasksForEdgeChromium();
    registerContentPreviewTasks();
    registerPdpTasks();
    registerLocalNewsTasks();
    registerFetchAppAnonCookie();
    registerFetchIndustryNewsArticles();

    // Start independent tasks here
    loadConfigTree();
})();
